export enum EPathologie {
	palliatif = "palliatif",
	diabetic = "diabetic",
	cancer = "cancer",
	mucoviscidose = "mucoviscidose",
	dependant = "dependant",
}